export default "__VITE_ASSET__D2t5GKn___"